export default "__VITE_ASSET__9a029084__"